/* eslint-disable default-case */
import { SCHOOL_LEVELS } from "../constants/school";
import moment from "jalali-moment";
export function generateCode(length = 7) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export function handleWebsiteAddress() {
  const host = window.location.host;
  const indexOfSubDomain = host.indexOf(".");
  const websiteAddress = host.substr(indexOfSubDomain + 1);
  return `${window.location.protocol}//${websiteAddress}`;
}
export function handleSchoolLevelData(level, grade) {
  if (level === 0) return {};
  const levelData = SCHOOL_LEVELS.filter((i) => i.value === level)[0];
  const gradeData = levelData?.gradeOptions?.filter(
    (i) => i.value === grade
  )[0];
  return levelData
    ? { ...levelData, grade: gradeData?.name, gradeNumber: gradeData?.value }
    : null;
}

export function faToEnNumber(number) {
  if (number === "۰") return 0;
  if (!number) return null;

  number = number.toString();

  const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const englishDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  for (let i = 0; i < farsiDigits.length; i++) {
    number = number.replace(new RegExp(farsiDigits[i], "g"), englishDigits[i]);
  }

  return number;
}
export function Jdate(date, timestamp = true, now = false, format = null) {
  var m = moment(!now ? new Date(timestamp ? date * 1000 : date) : Date());
  m.locale("fa");
  var output =
    m.format("ddd") +
    " " +
    m.format("DD") +
    " " +
    m.format("MMM") +
    " " +
    m.format("YYYY") +
    ", " +
    m.format("HH:mm");
  return format ? enToFaDigit(m.format(format)) : output;
}

export function enToFaDigit(number) {
  if (!number) return "۰";
  const data = {
    1: "۱",
    2: "۲",
    3: "۳",
    4: "۴",
    5: "۵",
    6: "۶",
    7: "۷",
    8: "۸",
    9: "۹",
    0: "۰",
  };
  let result = "";
  number = number.toString();

  for (var i = 0; i < number.length; i++) {
    if (data[number[i]]) result += data[number[i]];
    else result += number[i];
  }

  return result;
}
// separate 3 by 3 digits of number with comma in farsi
export function numberWithCommas(number) {
  // return Number(Number(number).toFixed(2)).toLocaleString("fa");
  if (number === 0) return "۰";
  if (!number) return null;

  const numberIsNegative = number < 0;
  number = faToEnNumber(number);
  let decimals = number.toString()?.split(".")[1];
  if (parseFloat(decimals)) number -= parseFloat("0." + decimals);
  number = number.toString().replaceAll(",", "").replace("-", "");
  // number = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  var separatedNumber = "";
  var count = 0;
  for (var i = number.length - 1; i >= 0; i--) {
    separatedNumber = number[i] + separatedNumber;
    count++;
    if (count === 3 && i !== 0) {
      separatedNumber = "," + separatedNumber;
      count = 0;
    }
  }
  if (decimals)
    separatedNumber += parseFloat("0." + decimals)
      .toString()
      ?.split("0")[1];

  if (numberIsNegative) separatedNumber += "-";

  return enToFaNumber(separatedNumber);
}
export function enToFaNumber(number) {
  if (number === 0) return "۰";
  if (!number) return null;
  const data = {
    1: "۱",
    2: "۲",
    3: "۳",
    4: "۴",
    5: "۵",
    6: "۶",
    7: "۷",
    8: "۸",
    9: "۹",
    0: "۰",
  };
  let result = "";
  number = number.toString();

  for (var i = 0; i < number?.length; i++) {
    if (data[number[i]]) result += data[number[i]];
    else result += number[i];
  }

  return result;
}

export function faToEnDigits(input) {
  if (input === undefined) return;
  var returnModel = "",
    symbolMap = {
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      "۰": "0",
    };
  input = input.toString();
  for (var i = 0; i < input.length; i++)
    if (symbolMap[input[i]]) returnModel += symbolMap[input[i]];
    else returnModel += input[i];
  return returnModel;
}

export function carTypeToName(cars = [], type) {
  let result = "مشخص نیست";
  cars.forEach((car) => {
    if (type === car.label) {
      result = car.title;
    }
  });
  return result;
}
export function handleGenderText(gender) {
  switch (gender) {
    case "male":
      return "مرد";
    case "female":
      return "زن";
  }
}
export function statusData(status) {
  switch (status) {
    case "set":
      return { title: "درخواست اولیه", label: "default" };
    case "disable":
      return { title: "غیرفعال", label: "danger", color: "status_red" };
    case "enable":
      return { title: "فعال", label: "info", color: "status_green" };
    case "fix":
      return {
        title: "تعیین پرداخت",
        label: "warning",
        color: "status_orange",
      };
    case "paid":
      return { title: "پرداخت شده", label: "success", color: "status_blue" };
    case "expired":
      return { title: "منقضی", label: "yellow", color: "status_yellow" };
    case "arrival":
      return { title: "رسیده", label: "success", color: "status_blue" };
    case "ontheway":
      return { title: "در مسیر", label: "success", color: "status_blue" };
    case "cancel":
      return { title: "کنسل", label: "warning", color: "status_orange" };
    default:
      return { title: "Unknown", label: "default", color: "status_gray" };
  }
}

export function toHHMMSS(date, isHours = true, isMin = true, isSec = true) {
  var sec_num = parseInt(date); // don't forget the second param

  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  // var text = ""
  var text = isHours ? hours + (isMin ? ":" : "") : "";
  text += isMin ? minutes + (isSec ? ":" : "") : "";
  text += isSec ? seconds : "";
  return text;
}
